import { MARKET_FUNCTION_SUPPORT } from '@/pages/Market/_constants/const';
import BadgeSquare from '@/components/atoms/BadgeSquare';

const FEATURE_LABELS = [
  '주문수집',
  '정산금 수집',
  '주문확인처리',
  '발송처리 및 송장입력',
  '상품 취소 처리',
  '클레임 접수',
  '리뷰 수집',
  '리뷰 답변 작성',
  '문의 수집',
  '문의 답변 작성',
];

const ProvideFeatures = ({ marketNameEnglish }: { marketNameEnglish: string }) => {
  const market = MARKET_FUNCTION_SUPPORT[marketNameEnglish];
  if (!market) return null;

  // 기능 분류
  const available = FEATURE_LABELS.filter((label) => market[label] === 'O');
  const preparing = FEATURE_LABELS.filter((label) => market[label] === 'X');

  return (
    <div className="w-full rounded-[16px] bg-white p-4">
      <div className="flex flex-col gap-[24px]">
        {/* 사용 가능한 기능 */}
        <div className="flex flex-col gap-[12px]">
          <div className="font-semibold text-gr-800">이런 기능들을 사용할 수 있어요</div>
          <div className=" flex flex-wrap gap-[10px]">
            {available.map((label) => (
              <BadgeSquare key={label} variant="purple" size="registerBadge">
                {label}
              </BadgeSquare>
            ))}
          </div>
        </div>

        {/* 준비중인 기능 */}
        {preparing.length > 0 && (
          <div className="flex flex-col gap-[12px]">
            <div className="font-semibold text-gr-800">준비중인 기능이에요</div>
            <div className=" flex flex-wrap gap-[10px]">
              {preparing.map((label) => (
                <BadgeSquare key={label} variant="muted" size="registerBadge">
                  {label}
                </BadgeSquare>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProvideFeatures;
